// extracted by mini-css-extract-plugin
export default {"h2":"Agenda_h2__87PV+","table":"Agenda_table__E7b7w","link":"Agenda_link__x7d00","arrowIcon":"Agenda_arrowIcon__etw2D","td":"Agenda_td__N7KxH"};